module.exports = __webpack_public_path__ + "static/media/Paint It Black.3d75cded.png";